/* screens/crm/CustomFields.jsx — рендер ДИНАМИЧЕСКИХ полей лида по схеме воронки.
   Схема (defs) приходит из pipeline.custom_fields: [{key,label,type,options?}].
   Все поля необязательны. Используется и в форме создания, и в карточке лида. */
import React from 'react';
import { Field, NativeSelect, NumberInput, Textarea, TextInput } from '../../components/ui/Field.jsx';

function CustomFieldInput({ def, value, onChange }) {
  if (def.type === 'number') {
    return <NumberInput value={value ?? ''} onChange={onChange} />;
  }
  if (def.type === 'textarea') {
    return <Textarea minRows={3} maxRows={10} value={value ?? ''}
      onChange={(e) => onChange(e.target.value)} />;
  }
  if (def.type === 'select') {
    return (
      <NativeSelect value={value ?? ''} onChange={(e) => onChange(e.target.value)}
        options={[{ value: '', label: '— не выбрано —' },
          ...(def.options || []).map((o) => ({ value: o, label: o }))]} />
    );
  }
  if (def.type === 'date') {
    return <TextInput type="date" value={value ?? ''} onChange={(e) => onChange(e.target.value)} />;
  }
  return <TextInput value={value ?? ''} onChange={(e) => onChange(e.target.value)} />;
}

function CustomFields({ defs = [], values = {}, onChange }) {
  if (!defs.length) return null;
  const set = (key) => (v) => onChange({ ...values, [key]: v });
  return (
    <div className="crm-grid2">
      {defs.map((d) => (
        // длинный текст занимает обе колонки сетки — иначе textarea сжат в половину
        <Field key={d.key} label={d.label}
          className={d.type === 'textarea' ? 'crm-field--full' : undefined}>
          <CustomFieldInput def={d} value={values[d.key]} onChange={set(d.key)} />
        </Field>
      ))}
    </div>
  );
}

export { CustomFields };
